import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.manage-application.integration-developers.remove-configuration', {
        url: '/remove-configuration',
        component: 'companyManageApplicationIntegrationDevelopersRemoveConfiguration',
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/integration-developers/remove-configuration/remove-configuration.state.js